import React, { useEffect, useState } from "react";
import closed from "assets/images/we-are-closed.svg";
import { useAppSelector } from "hooks/store";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import CircularProgress from "@mui/material/CircularProgress";

const ShopClosed = () => {
  const { settings, companyData } = useAppSelector(({ main }) => main);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // When required data is available → stop loading
    if (settings && companyData) {
      setLoading(false);
    }
  }, [settings, companyData]);

  return (
    <div className="h-screen">
      {/* HEADER */}
      <div className="h-[60px] bg-primary px-[20px] flex items-center shadow-[0px_10px_10px_5px_#00000024] z-10">
        {settings?.showLogo !== 0 ? (
          <div
            onDoubleClick={() => {
              window.location.href = "/admin/setting/time";
            }}
            className="text-white !px-1.5 relative"
          >
            <img
              src={companyData?.logoUrl}
              alt="Logo"
              className="h-14 w-14 rounded-md mr-3"
            />
          </div>
        ) : (
          <div
            onDoubleClick={() => {
              window.location.href = "/admin/setting/time";
            }}
            className="text-white !px-1.5 relative"
          >
            <AdminPanelSettingsIcon className="text-white" />
          </div>
        )}

        {!!settings?.ShowCompanyName && !!companyData?.companyName && (
          <a href="/">
            <h1 className="text-lg md:text-xl font-bold text-themeSelColor">
              {companyData.companyName}
            </h1>
          </a>
        )}
      </div>

      {/* BODY */}
      <div className="flex flex-col min-h-screen justify-center items-center bg-gray-50">
        {loading ? (
          /* ✅ LOADING STATE */
          <div className="flex flex-col items-center gap-4">
            <CircularProgress size={48} />
            <p className="text-gray-500 text-sm">Loading store status…</p>
          </div>
        ) : (
          /* ✅ CLOSED IMAGE (AFTER LOAD) */
          <img
            src={closed}
            alt="Closed Sign"
            className="max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg h-auto shadow-lg rounded-lg"
          />
        )}
      </div>
    </div>
  );
};

export default ShopClosed;
